const close = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.414%2012l6.364%206.364-1.414%201.414L12%2013.414l-6.364%206.364-1.414-1.414L10.586%2012%204.222%205.636l1.414-1.414L12%2010.586l6.364-6.364%201.414%201.414z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  close as default
};
//# sourceMappingURL=close.svg.es.js.map
